import { TchekService } from './../service/tchek.service';
import { ClassificationResultDataModel } from './../model/classificationDetection.model';
import { Component, OnInit } from '@angular/core';
import { Ng2ImgMaxService } from 'ng2-img-max';
import { TchekImage } from '../model/image';
import { ImagesService } from '../service/images.service';
import { ParametersService } from '../service/parameters.service';

@Component({
  selector: 'app-detection',
  templateUrl: './detection.component.html',
  styleUrls: ['./detection.component.less']
})
export class DetectionComponent implements OnInit {


  constructor(private ng2ImgMaxService: Ng2ImgMaxService,
    private _tchekService: TchekService,
    private _imageService: ImagesService,
    public readonly _imagesService: ImagesService) {
  }

  change() {
    this.result = undefined;
    this.resultClassification = undefined;
    this.url = undefined
    this.opacityH = 1
    this.opacityP = 1
    this.opacityC = 1
  }

  ngOnInit() {
  }

  opacityH = 1
  opacityP = 1
  opacityC = 1
  typeResult = '/detection/image'
  url: string 
  urlBackground : string = "https://app.tchek.fr/background_v1.jpg"
  load = false
  result: {
    heatmap: string, parts: string, url?: string, b64?: string, car: string, damages: any,
    parts_data: any,
  }
  resultClassification: ClassificationResultDataModel
  files: File[] = [];


  validateUrl() {
    this.opacityH = 1
    this.opacityP = 1
    this.opacityC = 1
    this.result = undefined
    this.resultClassification = undefined
    this.load = true

    let url = this.typeResult
    if(this.typeResult == "/remarketing/"  && this._imageService.removeBackground){
      url = "/remarketing/removeBackground"
    }else if(this.typeResult == "/remarketing/"  && !this._imageService.removeBackground){
      url = "/remarketing/blur"
    }
    if(this.typeResult == "/read/"  && this._imageService.vin){
      url = "/read/vin"
    }
    if(this.typeResult == "/read/"  && this._imageService.mileage){
      url = "/read/mileage"
    }
    if(this.typeResult == "/read/"  && this._imageService.licencePlate){
      url = "/read/licencePlate"
    }

    this._imagesService.runDetectionImage(this.url, undefined, url,undefined,undefined,undefined,this.urlBackground)
      .then(data => {
        console.log(data);
        this.typeResult = data.route
        if (data.route !== '/classification/image' && data.error === undefined)
          if ((data.route == '/remarketing/removeBackground' || data.route == '/remarketing/blur') && data.error === undefined){
            this.result = {
              parts: undefined, damages: undefined,
              parts_data: undefined, heatmap: data.b64,url: this.url.valueOf(), car: undefined
            }
            console.log("sbe b",data.b64)
          }else if ((data.route == '/read/vin' || data.route == '/read/mileage' || data.route == '/read/licencePlate') && data.error === undefined){
            this.result = {
              parts: undefined, damages: JSON.stringify(data),
              parts_data: undefined, heatmap: undefined,url: this.url.valueOf(), car: undefined
            }
          }else{
            this.result = {
              parts: data.detections.parts, damages: JSON.stringify(data.detections.damages),
              parts_data: JSON.stringify(data.detections.parts_data), heatmap: data.detections.heatmap, url: this.url.valueOf(), car: data.detections.car
            }
          }
         
        else {
          this.result = undefined
          this.resultClassification = data.data as ClassificationResultDataModel
        }
        this.url = undefined
        this.load = false;
      }).catch(err => { this.load = false; console.log(err); this.result = undefined })
  }

  async onSelect(event) {
    this.opacityH = 1
    this.opacityP = 1
    this.opacityC = 1
    this.url = undefined
    if (this.files.length < 1)
      this.files.push(...event.addedFiles);
    else {
      this.files.splice(0, 1);
      this.files.push(...event.addedFiles);
    }
    if (this.files
      && this.files[0]) {
      this.result = undefined
      this.resultClassification = undefined
      this.load = true


      try {
        let file = this.files[0]
        if ((file.size / 1000000) > 3) { // update compress image
          let compress = await this._imagesService.compressImage(window.URL.createObjectURL(file))
          console.log(compress);
          compress = compress.replace(/^data:.+;base64,/, '');

          let url = this.typeResult
            if(this.typeResult == "/remarketing/"  && this._imageService.removeBackground){
              url = "/remarketing/removeBackground"
            }else if(this.typeResult == "/remarketing/"  && !this._imageService.removeBackground){
              url = "/remarketing/blur"
            }
            if(this.typeResult == "/read/"  && this._imageService.vin){
              url = "/read/vin"
            }
            if(this.typeResult == "/read/"  && this._imageService.mileage){
              url = "/read/mileage"
            }
            if(this.typeResult == "/read/"  && this._imageService.licencePlate){
              url = "/read/licencePlate"
            }

          this._imagesService.runDetectionImage(undefined, compress, url,undefined,undefined,undefined,this.urlBackground)
            .then(data => {
              console.log(data);
              this.typeResult = data.route
              if (data.route !== '/classification/image' && data.error === undefined){
                if ((data.route == '/remarketing/removeBackground' || data.route == '/remarketing/blur') && data.error === undefined){
                  this.result = {
                    parts: undefined, damages: undefined,
                    parts_data: undefined, heatmap: data.b64, b64: compress, car: undefined
                  }
                  console.log("sbe b",data.b64)
                }else if ((data.route == '/read/vin' || data.route == '/read/mileage'  || data.route == '/read/licencePlate') && data.error === undefined){
                  this.result = {
                    parts: undefined, damages: JSON.stringify(data),
                    parts_data: undefined, heatmap: undefined, b64: compress, car: undefined
                  }
                }else{
                  this.result = {
                    parts: data.detections.parts, damages: JSON.stringify(data.detections.damages),
                    parts_data: JSON.stringify(data.detections.parts_data), heatmap: data.detections.heatmap, b64: compress, car: data.detections.car
                  }
                }
              }else {
                this.result = undefined
                this.resultClassification = data.data as ClassificationResultDataModel
              }
              this.load = false;
            }).catch(err => { this.load = false; console.log(err); this.result = undefined })


        } else {
          let reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onloadend = (() => {
            console.log('reader0', reader);
            var b64 = reader.result.toString()
            let file = b64.replace(/^data:.+;base64,/, '');

            let url = this.typeResult
            if(this.typeResult == "/remarketing/"  && this._imageService.removeBackground){
              url = "/remarketing/removeBackground"
            }else if(this.typeResult == "/remarketing/"  && !this._imageService.removeBackground){
              url = "/remarketing/blur"
            }
            if(this.typeResult == "/read/"  && this._imageService.vin){
              url = "/read/vin"
            }
            if(this.typeResult == "/read/"  && this._imageService.mileage){
              url = "/read/mileage"
            }
            if(this.typeResult == "/read/"  && this._imageService.licencePlate){
              url = "/read/licencePlate"
            }
            
           
            this._imagesService.runDetectionImage(undefined, file, url,undefined,undefined,undefined,this.urlBackground)
              .then(data => {
                console.log(data);
                this.typeResult = data.route
                if (data.route !== '/classification/image' && data.error === undefined)
                  if ((data.route == '/remarketing/removeBackground' || data.route == '/remarketing/blur') && data.error === undefined){
                    this.result = {
                      parts: undefined, damages: undefined,
                      parts_data: undefined, heatmap: data.b64, b64: file, car: undefined
                    }
                    console.log("sbe b",data.b64)
                  }else if ((data.route == '/read/vin' || data.route == '/read/mileage'  || data.route == '/read/licencePlate') && data.error === undefined){
                    this.result = {
                      parts: undefined, damages: JSON.stringify(data),
                      parts_data: undefined, heatmap: undefined, b64: file, car: undefined
                    }
                  }else{
                    this.result = {
                      parts: data.detections.parts, damages: JSON.stringify(data.detections.damages),
                      parts_data: JSON.stringify(data.detections.parts_data), heatmap: data.detections.heatmap, b64: file, car: data.detections.car
                  }
                }
                else {
                  this.result = undefined
                  this.resultClassification = data.data as ClassificationResultDataModel
                }
                this.load = false;
              }).catch(err => { this.load = false; console.log(err); this.result = undefined })

            this.files = []

          }).bind(this);
        }
        this.files = []
      } catch (error) {
        console.log(error);
      }

    }
  }

  getData(obj): any[] {
    let data = Object.entries(obj)
    data.forEach(e => {
      e[1] = this.getgentries(e[1])
    })
    return data
  }

  getgentries(obj): [string, number][] {
    let data: [string, number][] = Object.entries(obj) as [string, number][]
    data.forEach(e => {
      e[1] = e[1] * 100
    })
    return data
  }

  onRemove(event) {
    this.files.splice(this.files.indexOf(event), 1);
  }

}



// WEBPACK FOOTER //
// ./src/app/detection/detection.component.ts